export default "__VITE_ASSET__77fca469__"